module.exports = __webpack_public_path__ + "static/media/poop-yellow-type-4-copy-2.c20e1853.svg";